/**
 * 휴대전화 포멧 적용
 * 하이픈 적용.
**/
export const fmtPhone = (val) => {
    const nums = val
                  .replace(/[^0-9]/g, "") // 숫자만
                  .replace(/(^01[0-9])(\d{3,4})(\d{4}$)/, "$1-$2-$3");
    return nums;
};

/**
 * 일반전화 포멧 적용
**/
export const fmtTel = (val) => {
    if (!val) return "";
    // 숫자만 추출
    const onlyNums = val.replace(/[^0-9]/g, "");

    if (onlyNums.length < 4) {
        return onlyNums;
    } else if (onlyNums.length < 7) {
        return onlyNums.replace(/(\d{3})(\d{1,3})/, "$1-$2");
    } else if (onlyNums.length < 11) {
        return onlyNums.replace(/(\d{3})(\d{3})(\d{1,4})/, "$1-$2-$3");
    } else {
        return onlyNums.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    }
};

/**
 * 왼쪽 String 적용(적용 정보가 없는 경우 공백적용)
**/
export const fmtLpad = (val, cnt, char=" ") => {
    if (!val) return "";
    return String(val).padStart(cnt, char);
};

/**
 * 오른쪽 String 적용(적용 정보가 없는 경우 공백적용)
**/
export const fmtRpad = (val, cnt, char=" ") => {
    if (!val) return "";
    return String(val).padEnd(cnt, char);
};

// 날짜 표시(yyyy-mm-dd)
export const formatYyyyMmDd = (str) => {
  if (!str || str.length < 8) return "";
  return `${str.slice(0, 4)}-${str.slice(4, 6)}-${str.slice(6, 8)}`;
};

// 날짜 + 시간까지 표시(2025-11-18 14:47:12)
export const formatFullDateTime = (str) => {
  if (!str || str.length < 14) return "";
  return (
    `${str.slice(0, 4)}-${str.slice(4, 6)}-${str.slice(6, 8)} ` +
    `${str.slice(8, 10)}:${str.slice(10, 12)}:${str.slice(12, 14)}`
  );
};
